// extracted by css-extract-rspack-plugin
export default {"coverageRequirementsCount":"coverageRequirementsCount-R7JEUt","requirementIcon":"requirementIcon-hANWET","statusColumn":"statusColumn-iIw4Sp"};